import { useState } from 'react'
import styled from '@emotion/styled'
import Button from 'antd/lib/button'

import TabContent from './TabContent'

const LMS = () => {
  const [current, setCurrent] = useState(1)
  const handleClickTab = (tabNumber) => setCurrent(tabNumber)
  const getType = (tabNumber) => {
    if (current === tabNumber) return 'primary-fill'
    return 'primary'
  }

  return (
    <Page>
      <div className='intro-finnovo'>
        <img class='intro-finnovo-bg' src='/finnovo/jigsaw.jpg' alt='' />
        <div className='intro-finnovo-content'>
          <div className='compony-name'>Loan Management System</div>

          <div className='intro-compony-info'>
            <div className='intro-compony-info-center'>
              Our loan management module empowers lending providers to design, configure, test and
              releaser loan products in a short timeframe, which allows providers to anticipate and
              respond to the evolving market needs.
            </div>
          </div>
        </div>
      </div>
      <div className='content-page'>
        <div className='content-page-header'>
          <Button type={getType(1)} onClick={() => handleClickTab(1)}>
            Product Engine
          </Button>
          <Button type={getType(2)} onClick={() => handleClickTab(2)}>
            Calculation Engine
          </Button>
          <Button type={getType(3)} onClick={() => handleClickTab(3)}>
            Loan Operation
          </Button>
          <Button type={getType(4)} onClick={() => handleClickTab(4)}>
            Accounting & Report
          </Button>
        </div>
        {current === 1 && (
          <TabContent
            title='Product Engine'
            textContent={
              <>
                Create diverse and flexible financial products by configuring dozens of parameters.
                Reach new markets with lending products of any type:
                <br /> - Unsecured and secured loans
                <br /> - Asset based financing
                <br /> - Installment
                <br /> - Revolving credit line
              </>
            }
            img='/finnovo/20944141.jpg'
            textPosition='left'
          />
        )}
        {current === 2 && (
          <TabContent
            title='Calculation Engine'
            textContent={
              <>
                From the time the loan is disbursed/approved until payment is completed, Finnovo
                software streamlines the entire loan management process.
                <br /> - Set up calculations for a number of loan types
                <br /> - Keep your business compliant with loan operation regulations
                <br /> - Configure, calculate and track payment schedules
                <br /> - Perform day-to-day calculations for accruals, write-offs
              </>
            }
            img='/finnovo/Mar-Business_11.jpg'
            textPosition='right'
          />
        )}
        {current === 3 && (
          <TabContent
            title='Loan Operation'
            textContent={
              <>
                Enhance your portfolio performance with smart loan operation. Add 100% flexibility
                and freedom to loan servicing.
                <br /> - Basic operations. Initial interest, commissions, and fees accrual
                <br /> - Disbursement and repayment
                <br /> - Payment delay. Set for a specific period of time or date
                <br /> - Loan reschedule. Change the loan structure and term
                <br /> - Loan top-up. Add an additional amount to the existing principal
                <br /> - Pause penalties accrual/ Payment holidays
                <br /> - Allow integration with disbursement/repayment channels
                <br /> - bucket-based approach to management DPD
              </>
            }
            img='/finnovo/20943673.jpg'
            textPosition='left'
          />
        )}
        {current === 4 && (
          <TabContent
            title='Accounting & Report'
            textContent={
              <>
                Generate predefined number of reports. Our technology is open allowing integration
                with variety of accounting packages.
              </>
            }
            img='/finnovo/4389.jpg'
            textPosition='right'
          />
        )}
      </div>
    </Page>
  )
}
const Page = styled.div`
  .intro-finnovo {
    height: 500px;

    .intro-finnovo-bg {
      /* opacity: 0.6; */
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 565px;
      object-fit: cover;
      filter: brightness(50%);
    }
    .intro-finnovo-content {
      position: relative;
      padding: 40px;
      left: 50%;
      top: 50%;
      transform: translateY(-50%) translateX(-50%);
      text-align: center;

      .compony-name {
        @media only screen and (max-width: 700px) {
          font-weight: bold;
          font-size: 20px;
        }
        color: #ffffff;
        /* font-weight: bold; */
        font-size: 50px;
        padding: 20px 0;
      }
      .intro-compony-info {
        @media only screen and (max-width: 700px) {
          font-size: 16px;
        }
        display: flex;
        justify-content: center;
        color: #ffffff;
        font-size: 20px;
        .intro-compony-info-center {
          @media only screen and (max-width: 700px) {
            width: 100%;
          }
          width: 60%;
        }
      }
    }
  }
  .content-page {
    padding: 20px;
    /* height: 200px; */
    /* background: red; */
    .content-page-header {
      @media only screen and (max-width: 700px) {
        padding: 20px;
      }
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 20px 60px;
      button {
        margin: 10px 0;
        padding: 0 30px;
        height: 46px;
        font-size: 19px;
        min-width: 290px;
      }
    }
  }
`

export default LMS
